import { ReactComponent as Spinner } from './spinner.svg';
import './spinner.css';
import classNames from 'classnames';

type LoaderProps = {
  full?: boolean;
  content?: string;
};

function Loader({ full = true, content = DEFAULT_LOADER_CONTENT }: LoaderProps) {
  return (
    <div
      data-testid='loader'
      className={classNames(
        'flex flex-col items-center justify-center text-center',
        full ? 'h-screen' : 'py-4'
      )}
    >
      <Spinner width='70' className='spinner' />
      <div className='mt-5'>{content}</div>
    </div>
  );
}

export const DEFAULT_LOADER_CONTENT = 'لطفا منتظر بمانید.';

export default Loader;
